import React from "react";
import { Box, Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import CustomDrawer from "../../components/drawer/drawer.component";
import ReviewComponent from "../../components/reviews/review.component";
import { Height } from "@mui/icons-material";
import OrdersComponent from "../../components/orders/orders.component";

const OrdersPage = () => {
  let { section } = useParams();

  return (
    <div className="product">
      <CustomDrawer section={"orders"} />

      <Divider orientation="vertical" className="divider" />
      <div className="component">
        <OrdersComponent />
      </div>
    </div>
  );
};

export default OrdersPage;
